import React from "react";
import { AddMasterDataProps } from "./Index";
import { Title } from "../../../../../stories/Title/Title";
import InputHoc from "../../../../common/Input/Index";
import { emptyFunc } from "../../../../../utils/constants";
import { Operation } from "../../../../../utils/Enum.types";

const Add = ({ formData, handleValueChange, meta,operation }: AddMasterDataProps) => {
  return (
    <>
      <div className="master-data__add">
        <Title variant="subtitle1">{operation === Operation.UPDATE ? "Update" : "Add"} Manufacturer</Title>
        <div className="master-data__add--form">
          <InputHoc
            LabelName={`Manufacturer Description`}
            values={formData.groupName}
            name="groupName"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleValueChange(e, meta)
            }
            onKeyDown={emptyFunc}
            autoFocus
            required
          />
        </div>
      </div>
    </>
  );
};

export default Add;
